import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setProfileModalPage } from '../../../modules/profile/actions/creators'

import TicketsPage from '../components/TicketsPage/TicketsPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { profileModalPage } = profile

  return {
    accessToken,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
    },
    dispatch,
  )

const ConnectedTicketsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketsPage)

export default ConnectedTicketsPage
